import { CODE_CHANGE } from '../constants'

export default (fieldName, value) => (dispatch) => {
  dispatch({ type: CODE_CHANGE, fieldName, value })
}
